import './App.css';
import Layout from './components/Layout/Layout';
function App() {
  return (
    <div>
      <Layout/>
    </div>
  );
}

export default App;
